import * as React from "react";
import { forwardRef } from "react";
const SvgTelephoneBase = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M27.702 73.22C19.323 64.94 12.12 55.463 6.105 44.79l.377-1.221a14.3 14.3 0 0 1-1.44-7.42 14.28 14.28 0 0 1 13.44-13.114c4.253 8.176 8.668 15.313 13.266 21.17a14.28 14.28 0 0 1-8.534 6.77c7.443 9.752 15.397 18.464 25.58 26.8a14.28 14.28 0 0 1 7.024-9.514c7.392 5.502 14.465 10 21.156 13.265a14.28 14.28 0 0 1-9.03 12.504 14.28 14.28 0 0 1-10.182.063l-1.372.364C45.644 88.573 36.08 81.497 27.7 73.22Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgTelephoneBase);
export default ForwardRef;
